export default __webpack_public_path__ + "static/media/hyundai.5e97683c.png";